module.exports = __webpack_public_path__ + "static/media/detail.6778cd8a.svg";